import React, { Component } from 'react';
import partial from 'lodash/partial';
import { EmailInputField } from 'common/components/form_fields';
import LoginModal from 'login/components/login_modal';

/*
 * Lazy registration step.
 *
 * @author: Nathan Ozelim <nathan@startupfoundry.com>
*/
export default class LazyRegistration extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(fieldName, value) {
    const currentValue = this.props.input.value || {};
    this.props.input.onChange({...currentValue, [fieldName]: value});
  }

  render() {
    const {
      setLazyRegistering, nextStepLink, input, meta, showingLogin, onToggleLogin,
      loginForbidden
    } = this.props;
    const stepValues = input.value || {};
    const emailError = meta.error? meta.error.email : '';

    return (
      <div>
        <EmailInputField label="Email"
          meta={{
            invalid: !!emailError,
            touched: meta.touched,
            error: emailError
          }}
          input={{
            name: 'email',
            value: stepValues.email,
            onChange: (e) => this.handleChange('email', e.target.value),
            onBlur: partial(input.onBlur, input.value),
            onFocus: partial(input.onFocus, input.value),
          }}
        />
        { !loginForbidden &&
        <p>Already have an account? <a onClick={onToggleLogin}>Log in.</a></p> }
        <LoginModal showing={showingLogin} onClose={onToggleLogin} next={nextStepLink}
          onSuccess={partial(setLazyRegistering, false)}/>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./pap/components/common/input_fields/lazy_registration.jsx